import gql from 'graphql-tag';

const UpdatePassengerTicket = gql`
  mutation UpdatePassengerTicket($input: UpdatePassengerTicketMutationInput!) {
    updatePassengerTicket(input: $input) {
      ticket {
        id
        pnr
        passengerFirstName
        passengerLastName
        passengerPhone
        passengerEmail
        passengerLanguage
        employer
        promoCode {
          id
          code
          percentage
        }
        affiliate {
          id
          name
        }
        flightsPassengerTicketsConnection {
          edges {
            cursor
            node {
              id
              status
            }
          }
        }
      }
    }
  }
`;

export { UpdatePassengerTicket };



// WEBPACK FOOTER //
// ./src/mutations/UpdatePassengerTicket.js